import { TrainingRequestStatus } from "./TraningRequest";

export class ReportingParameters {
  DateFrom: Date;
  DateTo: Date;
  PreviousDateFrom: Date;
  PreviousDateTo: Date;
  Location: string;
  CaseNo: string;
  InstitutionId: number;
  PatientNo: string;
  StockLocationId: number;
  IsSuccess: boolean;
  movementType: string;
  InstitutionReferenceId: string;
  StockLocationReferenceId: string;
  PhysicalLocationReferenceId: string;
  PhysicalLocationId: number;
  UserName: string;
  FromStockLocationId: number;
  ToStockLocationId: number;
  dataPointCount: number;
  TrainingType: string;
  TrainingStatus: number;
  PackName: string;
  Barcode: string;
  IsManagedBySourceOfRecords: boolean;
  PINumber: string;
  PIReference: string;
}
